import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { H2 } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../constans';
import styles from './styles.module.scss';

const DeletePopUp = ({ doDelete = () => { }, close = () => { } }) => {

  return (
    <PopUp close={close} clickOutside={true} className={styles.pop_up}>
      <H2>Вы уверены?</H2>
      <Row style={{ marginTop: '30px' }}>
        <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={doDelete}>
          Удалить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default DeletePopUp;
